// extracted by mini-css-extract-plugin
export default {"left-hand-nav-submenu":"Submenu__left-hand-nav-submenu___a4WHq"};